import React from 'react';
import { Badge, Nav } from 'react-bootstrap';
import { fileTabVal } from './sideTypes';


type FileTabButtonProperties = {
    setMenuState: (state: fileTabVal) => void;
    stateValue: fileTabVal;
    setValue: fileTabVal;
    icon: string;
    title: string;
    showNew?: boolean;
}


function fileTabClasses(stateValue: fileTabVal, setValue: string): string {
    if (stateValue === setValue) {
        return "tab active"
    }
    return "tab"
}

export const FileTabButton = (props: FileTabButtonProperties) => {
    return (
        <Nav.Item className={fileTabClasses(props.stateValue, props.setValue)} onClick={() => props.setMenuState(props.setValue)}>
            <i className={"fa-duotone " + props.icon + " fa-action"} />
            <span>
                {props.title}
            </span>
            { props.showNew === true && 
                <Badge pill bg="indicator" text="light" className="indicator-new">NEW</Badge>
            }
        </Nav.Item>
    )
}
